package ai.jessie.shared.profile

import kotlinx.serialization.Serializable

@Serializable
data class GlobalProfileRequest(
    val revision: Long,
    val firstName: String,
    val lastName: String,
    val displayName: String,
    val locale: String,
)

@Serializable
data class MembershipProfileRequest(
    val organisationId: String,
    val revision: Long,
    val displayName: String? = null,
    val commentEmailNotifications: Boolean,
)

@Serializable
data class ProfileProposalRequest(
    val global: GlobalProfileRequest? = null,
    val membership: MembershipProfileRequest? = null,
)

@Serializable
data class SaveProfileRequest(val proposal: ProfileProposalRequest, val confirmed: Boolean)

@Serializable
data class GlobalProfileResponse(
    val revision: Long,
    val firstName: String,
    val lastName: String,
    val displayName: String,
    val locale: String,
)

@Serializable
data class MembershipProfileResponse(
    val organisationId: String,
    val organisationName: String,
    val revision: Long,
    val displayName: String?,
    val commentEmailNotifications: Boolean,
    val effectiveDisplayName: String,
)

@Serializable
data class OwnProfileResponse(
    val global: GlobalProfileResponse,
    val verifiedEmail: String,
    val membership: MembershipProfileResponse? = null,
)

@Serializable
data class ProfileFieldChangeResponse(
    val scope: String,
    val field: String,
    val previous: String?,
    val new: String?,
)

@Serializable
data class ProfileReviewResponse(
    val proposal: ProfileProposalRequest,
    val current: OwnProfileResponse,
    val changes: List<ProfileFieldChangeResponse>,
)

@Serializable
data class ProfileErrorResponse(
    val code: String,
    val fields: List<String> = emptyList(),
    val current: OwnProfileResponse? = null,
)

@Serializable data class EmailChangeNavigationResponse(val providerUri: String)
